import { render } from "./policyPhoto.vue?vue&type=template&id=d6b83ac0&scoped=true"
import script from "./policyPhoto.vue?vue&type=script&lang=js"
export * from "./policyPhoto.vue?vue&type=script&lang=js"

import "./policyPhoto.vue?vue&type=style&index=0&id=d6b83ac0&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b83ac0"]])

export default __exports__